import React, { useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useDispatch } from 'react-redux';
import { getNonRenewedSubscription } from '../../../services/subscriptionService';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
// Loader removed from this widget per request

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const NonRenewedSubscriptions = () => {
  const dispatch = useDispatch();
  const [chartData, setChartData] = useState(null);
  // Removed in-widget loader
  const fetchedRef = useRef(false);
  const inFlightRef = useRef(false);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        stacked: true,
        ticks: {
          padding: 10,
          display: true
        },
        afterTickToLabelConversion: function(scaleInstance) {
          const ticks = scaleInstance.ticks;
          const ticksPostion = scaleInstance.chart.scales.x.right;
          scaleInstance.chart.ctx.save();
          scaleInstance.chart.ctx.beginPath();
          ticks.forEach(function(tick) {
            scaleInstance.chart.ctx.moveTo(tick.x, ticksPostion);
            scaleInstance.chart.ctx.lineTo(tick.x, ticksPostion + 8);
            scaleInstance.chart.ctx.strokeStyle = '#E5E7EB';
            scaleInstance.chart.ctx.stroke();
          });
          scaleInstance.chart.ctx.restore();
        }
      },
      y: {
        beginAtZero: true,
        max: 80,
        grid: {
          color: '#E5E7EB',
        },
        border: {
          display: false,
        },
        stacked: true,
        ticks: {
          stepSize: 10,
          callback: function(value) {
            return value;
          }
        },
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 50,
          boxHeight: 14,
          usePointStyle: true,
          pointStyle: 'rectRounded',
          padding: 20,
        },
      },
      tickMarks: {
        enabled: true,
        tickLength: 8,
        tickColor: '#E5E7EB'
      }
    },
    barThickness: 15,
  };

  useEffect(() => {
    const fetchData = async () => {
      if (inFlightRef.current) return;
      inFlightRef.current = true;
      try {
        const res = await dispatch(getNonRenewedSubscription())?.unwrap();
        if (res?.success) {
          let d = res?.data || {};
          // Support array payloads like [{ month: 'August', total: 26, nonRenewed: 25 }, ...]
          if (Array.isArray(d)) {
            const labels = d.map((m) => m?.month ?? '');
            const total = d.map((m) => Number(m?.total) || 0);
            const nonRenewed = d.map((m) => Number(m?.nonRenewed) || 0);
            d = { labels, total, nonRenewed };
          }
          setChartData({
            labels: d.labels || ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
            datasets: [
              { label: 'Total', data: d.total || [], backgroundColor: '#B154C6', borderRadius: 0 },
              { label: 'Non-Renewed Subscriptions', data: d.nonRenewed || [], backgroundColor: '#14DFB9', borderRadius: 0 }
            ]
          });
        }
      } catch(_) {}
      inFlightRef.current = false;
    };
    if (!fetchedRef.current) {
      fetchedRef.current = true;
      fetchData();
    }
  }, [dispatch]);

  return (
    <div className="summary w-full p-4 h-[470px] flex flex-col bg-white rounded-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-[20px] font-poppins font-[600] text-[#303030] leading-none">Non-Renewed Subscriptions</h2>
      </div>
      <div className="flex-1 min-h-0">
        {chartData && <Bar options={options} data={chartData} />}
        {!chartData && (
          <div className="w-full h-full flex items-center justify-center text-[#767676] text-[14px]">No data</div>
        )}
      </div>
    </div>
  );
};

export default NonRenewedSubscriptions; 